import { InjectField } from 'core-app/shared/helpers/angular/inject-field.decorator';
import { TagsApiV3Service } from '../services/tags-api-v3.service';
import {
  ResourcesDisplayField,
} from 'core-app/shared/components/fields/display/field-types/resources-display-field.module';

export class TagsDisplayField extends ResourcesDisplayField {
  @InjectField() tagsApiV3Service:TagsApiV3Service;

  public get valueString():string {
    return this.stringValue.join(", ");
  }

  public render(element:HTMLElement, displayText:string):void {
    const values = this.resource[this.name];
    element.innerHTML = '';
    if (!values || values.length === 0) {
      this.renderEmpty(element);
    } else {
      this.renderValues(values, element);
    }
  }

  protected renderValues(values:any, element:HTMLElement) {
    values.forEach((value:any) => {
      const span = document.createElement('i');
      span.classList.add("tag");
      span.textContent = value.name;
      span.dataset.id = value.id;
      element.appendChild(span);

      this
        .tagsApiV3Service
        .tags
        .id(value.id)
        .get()
        .subscribe((tag:any) => {
          span.style.setProperty("--color", tag.color);
        });
    });
  }
}
